import script from "./svg-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./svg-icon.vue?vue&type=script&setup=true&lang=js"

import "./svg-icon.vue?vue&type=style&index=0&id=2b912b0e&lang=scss"

const __exports__ = script;

export default __exports__